import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

export interface Transcription { langue?: string; transcription?: string; traduction?: string; restants?: number; }

/** Résultat d'une dictée de formulaire : champs proposés (rien n'est enregistré), résumé, champs manquants */
export interface DicteeFormulaire {
  action: string;
  champs: { [cle: string]: any };
  resume?: string;
  manquants?: string[];
  restantes?: number;
}

/** Dictée : transcription de l'enregistrement puis extraction des champs d'un formulaire */
@Injectable({ providedIn: 'root' })
export class DicteeService {

  private readonly base = `${environment.BASE_URL}/api/assistant`;

  constructor(private http: HttpClient) {}

  transcrire(audio: Blob, langue: string): Observable<Transcription> {
    const fd = new FormData();
    const ext = audio.type.includes('ogg') ? 'ogg' : audio.type.includes('mp4') ? 'm4a' : audio.type.includes('wav') ? 'wav' : 'webm';
    fd.append('audio', audio, `dictee.${ext}`);
    fd.append('langue', langue);
    return this.http.post<Transcription>(`${this.base}/transcription`, fd);
  }

  formulaire(formulaire: string, texte: string, langue: string): Observable<DicteeFormulaire> {
    return this.http.post<DicteeFormulaire>(`${this.base}/dictee/formulaire`, { formulaire, texte, langue });
  }
}
